import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../../hooks/useFetch";


export default function TspSupplierReportFinal() {

  const { data, isLoading } = useFetch('tsp/getAllTsp')
  const navigate = useNavigate();

  const TspSupplierReportFinalData = (id) => {
    const routes = `/tspsupplierreportfinaldata`;
    navigate(routes, { state: id });
  };


  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">TSP Supplier Report</h1>
        </div>
        {/* <div className="table-responsive"> */}
        <table class="table">
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Year</th>
              <th>Created Date</th>
            </tr>
          </thead>
          {
            data && data.length > 0 ? (
              data.map((curData => {
                const { id, seller, year, createdAt } = curData;
                return (
                  <tr className='clickablerow'
                    key={id}
                    onClick={() => TspSupplierReportFinalData(id)}>
                    <td >{seller}</td>
                    <td >{year}</td>
                    <td >{createdAt}</td>
                  </tr>
                )
              }))) : (
              <span>No Tsp supplier reports data available.</span>
            )
          }
        </table>
        {/* </div> */}
      </main>
    </>
  );
}
